module.exports = __webpack_public_path__ + "img/OVS-1.900616f5.png";